<template>
  <div>
    <router-view :key="$route.fullPath" />
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'AdminRootView',
    computed: {
      ...mapGetters('tenantUser', ['isAdmin']),
    },
    mounted: function () {
      if (!this.isAdmin) {
        this.$store.commit('notification/setWarning', 'Access error');
        this.$router.push({ name: 'private-home', });
      }
    },
    watch: {
      isAdmin: function (newVal, oldVal) {
        if (!newVal) {
          this.$store.commit('notification/setWarning', 'Access error');
          this.$router.push({ name: 'private-home', });
        }
      },
    },
  };
</script>
